import { CCStyling, DefaultStyling } from "../CCStyling";
import { createElement } from "../CCUtility";
import { CCButtonVariant, CCIconVariant } from "../types/variants";

export function CCIcon(
  variant: CCIconVariant,
  iconClass: string = "",
  content: string = "",
  styling: CCStyling = DefaultStyling.blank,
  htmlAttributes: Record<string, string> = {}
): string {
  const styleDefault = ["arrow-left", "arrow-right", "plus", "remove"].includes(
    variant
  )
    ? DefaultStyling.pointer
    : DefaultStyling.genericIcon;
  return createElement(
    "span",
    `glyphicon glyphicon-${variant} ${iconClass}`,
    CCStyling.join(styleDefault, styling),
    content,
    htmlAttributes
  );
}

export function CCButton(
  variant: CCButtonVariant,
  btnClass: string,
  content: string,
  styling: CCStyling = DefaultStyling.blank,
  htmlAttributes: Record<string, string> = {}
): string {
  return createElement(
    "div",
    `btn btn-${variant} ${btnClass}`,
    CCStyling.join(DefaultStyling.button, styling),
    content,
    htmlAttributes
  );
}

export function CCGrid(
  gridClass: string,
  content: string,
  styling: CCStyling = DefaultStyling.blank,
  htmlAttributes: Record<string, string> = {}
): string {
  return createElement(
    "div",
    gridClass,
    CCStyling.join(DefaultStyling.grid, styling),
    content,
    htmlAttributes
  );
}

export function CCInstructions(
  divClass: string,
  content: string,
  styling: CCStyling = DefaultStyling.blank,
  htmlAttributes: Record<string, string> = {}
): string {
  return createElement(
    "div",
    divClass,
    CCStyling.join(DefaultStyling.instructions, styling),
    content,
    htmlAttributes
  );
}

export function CCHyperlink(
  aClass: string,
  content: string,
  styling: CCStyling = DefaultStyling.blank,
  htmlAttributes: Record<string, string> = {}
): string {
  return createElement(
    "a",
    aClass,
    CCStyling.join(DefaultStyling.hyperlink, styling),
    content,
    htmlAttributes
  );
}

export function CCJumper(key: string, tab: string, subtab?: string): string {
  const dataType = subtab == undefined ? " " : ` data-type="${subtab}" `;
  return `<span data-key="${key}" data-section="${tab}"${dataType}class="glyphicon glyphicon-share-alt cc-jumper" style="margin-left: 15px;" data-toggle="popover" data-placement="right" data-content="Jump to CV section"></span>`;
}
export function CCCollapser() {
  return CCButton(
    "default",
    "cc-collapser",
    "Collapse",
    CCStyling.fromObject({ "margin-left": "1rem" })
  );
}
